/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uploading_Please_WaitInputs */



/**
* | output |
* | --- |
* | "Uploading... please wait" |
*
* @param {Uploading_Please_WaitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const uploading_please_wait = /** @type {((inputs?: Uploading_Please_WaitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uploading_Please_WaitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Téléversement... veuillez patienter")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wird hochgeladen... bitte warten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento in corso... attendere prego")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка... пожалуйста, подождите.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subiendo... por favor espere")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在上传……请稍候")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アップロード中...お待ちください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपलोड हो रहा है... कृपया प्रतीक्षा करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregando... aguarde")
	return /** @type {LocalizedString} */ ("Uploading... please wait")
});